/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { x as index$F } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import redirectTo$1 from './dingTalk/index.js';
import redirectTo$2 from './ali1688/index.js';
import redirectTo$3 from './mini/index.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';
import '../../index-ee2c9aee.js';

var apiConfig = {
    web: {
        dingTalk: redirectTo$1,
        windvane: {
            ali1688: redirectTo$2,
        },
    },
    mini: redirectTo$3,
};
var extendRedirectTo = extend(apiConfig, 
/** baseRedirectTo 支持windvane容器、nebula容器 */
index$F);
var redirectTo = function (url, params) {
    if (typeof url === 'string') {
        return extendRedirectTo(__assign(__assign({}, params), { url: url }));
    }
    return extendRedirectTo(url);
};

export { extendRedirectTo, redirectTo };
